import { GetterTree } from "vuex";
import { IAgentState } from "@/core/interfaces/state/agentState.interface";
import { IAgentDetail, IAgentDetails } from "@/core/interfaces/agent.interface";
import { StoreState } from "@/store/type";
import { IPaginationMeta } from "@/core/interfaces/state/paginationMeta.interface";

const getters: GetterTree<IAgentState, StoreState> = {
  organization_users: (state): Array<IAgentDetails> => state.organization_users,
  isFetchingAgents: (state): boolean => state.isFetchingAgents,
  organizationAgents: (state): Array<IAgentDetail> => state.organization_agents,
  isFetchingOrganizationUsers: (state): boolean =>
    state.isFetchingOrganizationUsers,
  isFetchingAgent: (state): boolean => state.isFetchingAgent,
  organization_user: (state): IAgentDetails | null => state.organization_user,
  updatingAgentPermissions: (state): boolean =>
    state.isUpdatingAgentPermissions,

  agentPricingResponse: (state): IAgentState["agentPricingResponse"] =>
    state.agentPricingResponse,

  organizationAgentsPaginationMeta: (state): IPaginationMeta | null =>
    state.organizationAgentsPaginationMeta,
};

export default getters;
